<template>
  <div>
    <div class="text-sm font-semibold text-white">
      Motion Array
    </div>

    <nav class="flex mt-8">
      <ul class="space-y-3">
        <li>
          <a
            href="/"
            class="footer-link"
          >Home</a>
        </li>

        <li>
          <a
            href="/browse/"
            class="footer-link"
          >Marketplace</a>
        </li>

        <li>
          <a
            href="/plugins/"
            class="footer-link"
          >Plugins</a>
        </li>

        <li>
          <a
            href="/integrations/adobe/"
            class="footer-link"
          >Adobe Extensions</a>
        </li>

        <li>
          <a
            href="/requests/"
            class="footer-link"
          >Content Requests</a>
        </li>

        <li v-if="!isPaidUser">
          <a
            href="/pricing/"
            class="footer-link"
            onclick="clickOnPricing()"
          >Pricing</a>
        </li>

        <li>
          <a
            href="/business/"
            class="footer-link"
          >Business</a>
        </li>

        <li>
          <a
            href="https://lp.motionarray.com/ambassadors/"
            class="footer-link"
          >Become an Ambassador</a>
        </li>

        <li v-if="showReferAFriendLink">
          <a
            href="/referral/"
            class="footer-link"
            @click="clickReferAFriend"
          >
            Refer a friend
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import LinkGroup from './link-group.vue';

export default {
  components: {
    LinkGroup,
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isPaidUser() {
      return this.$store.getters.paidUser;
    },
    isAdmin() {
      return this.$store.state.user?.is_team_admin;
    },
    isHasTeam() {
      return this.$store.state.user?.has_team;
    },
    showReferAFriendLink() {
      return this.isLoggedIn && !this.isAdmin && !this.isHasTeam;
    },
  },

  methods: {
    clickOnPricing() {
      eventTracker(analyticsEvents.clickPricing);
    },
    clickReferAFriend() {
      eventTracker(analyticsEvents.buttonClicked, {
        flow: 'refer a friend',
        button_name: 'refer a friend',
        next_url: '/referral/',
        click_source: 'footer',
      });
    },
  },
};
</script>
